<template>
    <v-form ref="forgotPasswordForm" v-model="valid" lazy-validation>
        <div class="forgot-password__title">{{loginConstants.EMAIL_ASSOCIATED_WITH_YPO}}</div>
        <v-flex>
            <v-text-field
                id="password_reset_email_input"
                prepend-inner-icon="email"
                name="Email"
                autofocus
                v-model="email"
                :placeholder="loginConstants.EMAIL_PLACEHOLDER_PASSWORD_RESET"
                :rules="emailRules"
                @keyup="resetError()"
                data-qe-id="login_forgot-password_input"
                :disabled="isSubmitting"
                required
                v-on:keydown.enter.prevent>
            </v-text-field>
            <v-flex class="forgot-links">
                <span
                    id="password_further_assistance_icon"
                    data-qe-id="login_forgot-password_further-assistance_link"
                    @click="isExternalSpeaker? changeCardState(componentNames.spousePartnerResetPassword.component) : changeCardState(componentNames.passwordFurtherAssistance.component)"> 
                        {{loginConstants.EMAIL_RESET}}
                </span>
            </v-flex>
        </v-flex>
        <login-error class="forgot-password__error"></login-error>
        <v-flex class="password-assitance" v-if="!isExternalSpeaker">
            <span> {{loginConstants.PASSWORD_ASSISTANCE_MAIL}}</span>
            <em @click="launchEmailClient(loginConstants.ISSpeakerEmail)"> {{loginConstants.YPO_HELP_EMAIL}} </em>
        </v-flex>
        <v-card-actions v-if="!disableContinue">
            <v-layout row wrap>
                <v-btn
                    flat
                    large
                    id="return_to_home_btn"
                    data-qe-id="return_to_home_btn"
                    block
                    @click="returnToLogin()"
                    :disabled="isSubmitting">
                    {{loginConstants.CANCEL}}
                </v-btn>
                <v-btn
                    id="submit_password_reset_btn"
                    data-qe-id="submit_password_reset_btn"
                    color="ypo_blue"
                    @click="submit"
                    :disabled="!email.length || !valid || isSubmitting"
                    large
                    block>
                    {{loginConstants.SUBMIT}}
                </v-btn>
            </v-layout>
        </v-card-actions>
    </v-form>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex';
    import { storeAction } from "../../../store/storeActions.constant";
    import { storeGetters } from "../../../store/storeGetters.constant";
    import { loginConstants } from '../login.constants';
    import LoginError from "../LoginError";
    import { storeMutation } from '../../../store/storeMutations.constant';

    export default {
        name: 'ForgotPassword',
        components: { LoginError },
        data: () => ({
            loginConstants,
            valid: true,
            componentNames: loginConstants.componentNames,
            email: '',
            passwordRecoveryOptions: null,
            disableContinue: false,
            emailRules: [
                v => !!v || loginConstants.errors.EMAIL_REQUIRED,
                v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || loginConstants.errors.INVALID_EMAIL,
            ],
        }),
        props: {
            changeCardState: Function,
            toggleProgressIndicator: Function,
            isSubmitting: Boolean,
            returnToLogin: Function,
        },
        methods: {
            ...mapActions({
                getPasswordRecoveryOptions: `auth/${storeAction.getPasswordRecoveryOptions}`,
                submitSelectTypePasswordDelivery: `auth/${storeAction.submitSelectTypePasswordDelivery}`,
                clearErrorOnStateChange: `auth/${storeAction.handleLoginErrorMessage}`,
            }),
            ...mapMutations({
                setExternalSpeaker: `auth/${storeMutation.setExternalSpeaker}`,
            }),
            resetError() {
                if (!this.email.length) {
                    this.clearErrorOnStateChange(null);
                } else {
                    this.disableContinue = false;
                }
            },
            submit() {
                this.toggleProgressIndicator();
                if (this.$refs.forgotPasswordForm.validate()) {
                    this.getPasswordRecoveryOptions(this.email)
                        .then((resp) => {
                            return this.submitSelectTypePasswordDelivery({ recoveryCodeType: 'email', destination: resp.data.email });
                        })
                        .then(() => {
                            this.toggleProgressIndicator();
                            this.disableContinue = false;
                            this.changeCardState(this.componentNames.passwordCodeSent.component);
                        })
                        .catch(() => {
                            this.toggleProgressIndicator();
                            this.disableContinue = true;
                        });
                }
            },
            externalSpeaker() {
                this.setExternalSpeaker(this.$route.query.isSpeaker === "true" || this.$route.query.isspeaker === "true");
            },
            launchEmailClient(email) {
                window.location = `mailto:${email}`;
            },
        },
        computed: {
            ...mapGetters({
                recoveryData: storeGetters.recoveryData,
                isExternalSpeaker: `auth/${storeGetters.isExternalSpeaker}`,
            }),
        },
    };
</script>

<style lang="scss">
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

    .forgot-password {
        &__title {
            padding: 5px 10px 20px 5px;
            font-size: 16px;
            color: $black;
            opacity: 0.9;
        }

        &__success {
            padding: 10px 5px;
            border-top: 1px solid $ypo-gray;
            display: flex;
            flex-wrap: wrap;

            &-message {
                color: $ypo-blue;
            }

            &-email {
                color: $ypo-gold;
                padding-left: 5px;
            }
        }

        &__error {
            padding: 0 5px 10px;
        }

        &__resend {
            color: $ypo-blue-secondary;
        }
    }

    .v-btn__content {
        @include breakpoint(xs) {
            font-size: 12px !important;
        }
    }

    .v-card__actions {
        padding-right: 0 !important;

        @include breakpoint(xs) {
            padding: 0 !important;
        }
    }

    #submit_password_reset_btn {
        .v-btn__content {
            color: $white;
        }
    }

    .forgot-links {
        span {
            color: $ypo-cta !important;
            cursor: pointer;
        }
    }

    .password-assitance {
        margin: 40px 0 50px 0;
        em {
            color: $ypo-cta !important;
            cursor: pointer;
            font-style: normal;
            display: flex;
        }
    }
</style>
